import { TextField } from "@totalenergiescode/mobility-business-rev-design-system";
import {
  Suffix,
  translateField,
  useFormDataContext,
} from "@totalenergiescode/mobility-business-rev-form-data/components";
import { FormFieldContract } from "@totalenergiescode/mobility-business-rev-form-data/lib";

interface EditableTextFieldProps {
  field: FormFieldContract;
}

function EditableTextField({ field }: EditableTextFieldProps) {
  const { dataTestIdPrefix, translatorFor } = useFormDataContext();

  if (!field) return null;

  const value = field.value.asString();
  const currentValue = value.value() || value.defaultValue();

  const translator = translatorFor(field);
  const label = translateField(translator, field, Suffix.LABEL);

  const errorMessage = field.violations().join(", ");

  const required = field.required;
  const writable = field.writable;

  function handleFieldChange(event: React.ChangeEvent<HTMLInputElement>) {
    field.setValue(event.target.value);
  }

  return (
    <TextField
      type='text'
      label={label.toString()}
      value={currentValue}
      onChange={handleFieldChange}
      disabled={!writable}
      isError={Boolean(errorMessage)}
      errorText={errorMessage || ""}
      required={required}
      dataTestId={`${dataTestIdPrefix}-${field.id()}`}
    />
  );
}

export default EditableTextField;
